export function unlockButtonLabel(hasUnlock: boolean): string {
  return hasUnlock ? $localize`Edit Unlock` : $localize`Unlock`;
}
